<template>
	<section class="page-content-slim">
		<div class="container">
			<div class="row">
				<!-- Notifications database -->
				<div class="col-xs-12 col-sm-6 col-md-5 col-lg-5">
					<router-link to="/notifications">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Access the database
							</div>
							<!-- why hidden? -->
							<div class="nav-card-summary hidden">
								Explore all available regulation notifications for your region/s.
							</div>
						</div>
					</router-link>
				</div>
				<!-- Advanced search -->
				<div class="col-xs-12 col-sm-6 col-md-5 col-md-offset-1 col-lg-5 col-lg-offset-1">
					<router-link to="/advanced-search">
						<div class="nav-card-container">
							<div class="nav-card-title">
								Advanced search
							</div>
							<div class="nav-card-summary">
								Search for specific regulation notifications with as many details as you have,
								including: text, year, region or country, status and type of issue.
							</div>
						</div>
					</router-link>
				</div>
			</div>
			<!-- Market Access link -->
			<div class="row">
    			<div class="col-xs-12">
    				<hr class="hr-bold">
    				<a role="button" class="btn btn-primary btn-lg" style="font-size: 1.2em; font-weight: 700;margin-bottom: 20px;" href="https://supplements-good-practices.iadsa.org/market-access/" target="_blank">Market access overview</a>
    				<p style="margin-bottom: 0; padding: 0 20px;">Use the password <strong>redaccess24</strong>
    				</p>
    			</div>
    		</div>
			<hr class="hr-bold">
			<!-- Latest updates -->
			<div class="row">
				<div class="col-xs-12">
					<div class="h2-lg">
						Latest updates
					</div>
					<template v-if="loading">
						<div class="row">
							<div class="col-xs-12">
								<div class="container loading-container">
									<img class="section-loader" src="@/assets/images/iadsa-section-loader-admin.gif"/>
								</div>
							</div>
						</div>
					</template>
					<template v-else-if="regulations && regulations.length > 0">
						<div
							v-for="regulation in regulations"
							:key="regulation.id"
							class="list-container list-container-notifications"
						>
							<div class="row">
								<div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
									<template v-if="regulation.regions.length > 0" >
										<div class="sm-padding-bottom-10">
											<b-btn
												v-for="region in regulation.regions"
												:key="region.id"
												class="label label-red"
												@click="filterAndSearch('regions', region.id)"
											>
												&nbsp;{{ region.name }}&nbsp;
											</b-btn>
										</div>
									</template>
									<template v-else>
										<div class="sm-padding-bottom-10">
											<span class="label label-default">No regions set</span>
										</div>
									</template>
								</div>
								<div class="col-xs-12 col-sm-8 col-md-2 col-lg-2">
									<div class="sm-padding-bottom-10">
										<div class="no-margin">{{ formatStartDate(regulation.start_date) }}</div>
										<div class="no-margin" v-if="regulation.reference !== undefined && regulation.reference.length > 0">{{ `Ref: ${regulation.reference}` }}</div>
									</div>
								</div>
								<div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
									<div class="sm-padding-bottom-10">
										<div class="notification-list-heading">
											<router-link
												:to="`/resource/${regulation.id}`"
											>
												{{ regulation.title }}
											</router-link>
										</div>
									</div>
								</div>
								<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
									<div class="sm-padding-bottom-10">
										<b-btn
											class="label label-status"
											@click="filterAndSearch('status', regulation.status.id)"
										>{{ regulation.status.name }}</b-btn>
										<br/>
										<b-btn
											v-for="tag in regulation.tags"
											:key="tag.id"
											class="label label-gray"
											@click="filterAndSearch('tags', tag.id)"
										>
											&nbsp;{{ tag.name }}&nbsp;
										</b-btn>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="less" scoped>
	.loading-container {
		text-align: center;
	}
	.section-loader {
		max-width: 200px;
		height: auto;
		margin: 30px auto;
	}
</style>

<script>
import moment from 'moment';

export default {
	created() {
		this.getRegulations();
	},
	data() {
		return {
			title: 'Index',
			regulations: null,
			loading: false,
			selectedFilters: {
				regions: [],
				status: [],
				dates: [],
				tags: []
			}
		};
	},
	methods: {
		formatStartDate(startDate) {
			return moment(startDate).format('DD/MM/YYYY');
		},
		async getRegulations() {
			this.loading = true;
			const { data: { data: regulations } } = await this.$axios.get('/resource', { params: { limit: 5, page: 1 } });
			this.$set(this, 'regulations', regulations);
			this.loading = false;
		},
		filterAndSearch(type, id) {
			this.$set(this.selectedFilters, type, [id]);
			this.$router.push({
				path: '/notifications',
				query: {
					selectedFilters: this.selectedFilters
				}
			});
		}
	}
};
</script>
